export const CHAT_TEXTAREA_MAX_HEIGHT = 100;
// 14px font × 1.5 line-height (21) + 6px vertical padding on each side (12).
export const CHAT_TEXTAREA_MIN_HEIGHT = 33;

/**
 * Clamp a textarea scroll height to the allowed grow range.
 */
export function getTextareaResizeHeight(
  scrollHeight: number,
  maxHeight = CHAT_TEXTAREA_MAX_HEIGHT,
  minHeight = CHAT_TEXTAREA_MIN_HEIGHT,
): number {
  return Math.min(maxHeight, Math.max(minHeight, scrollHeight));
}

/**
 * Grow or shrink a textarea to fit its content up to the max height.
 */
export function applyTextareaResize(
  textarea: HTMLTextAreaElement,
  maxHeight = CHAT_TEXTAREA_MAX_HEIGHT,
): void {
  textarea.style.height = 'auto';
  const nextHeight = getTextareaResizeHeight(textarea.scrollHeight, maxHeight);
  textarea.style.height = `${nextHeight}px`;
  textarea.style.overflowY = textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
}

/**
 * Reset a textarea back to its single-line height after send.
 */
export function resetTextareaResize(
  textarea: HTMLTextAreaElement,
  minHeight = CHAT_TEXTAREA_MIN_HEIGHT,
): void {
  textarea.style.height = `${minHeight}px`;
  textarea.style.overflowY = 'hidden';
}
